import React, {useCallback, useState} from 'react';
import {SearchSource, SearchSourceType} from '../search-types';
import {useTranslation} from 'react-i18next';
import {SvgIcon} from '../../icons/svgIcon';
import {Icons} from '../../icons/icons';
import Dropdown from 'react-bootstrap/Dropdown';
import classNames from 'clsx';
import {useStateSources} from '../search-hooks';
import {fetchFacets, search, searchSourceSwitchedAction} from '../duck/search-actions';
import {SearchPageType} from '../search-config';
import {useDispatch} from 'react-redux';
import {useHistory} from 'react-router-dom';

export const SearchSources = React.memo(() => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();
    const sources = useStateSources();
    const [show, setShow] = useState<boolean>(false);

    const onToggle = () => {
        setShow(!show);
    };

    const renderSelectedValue = (): string => {
        const source: SearchSource | undefined = sources.find((source) => source.active);
        return source ? t('search.source.' + source.name) : '';
    };

    const triggerSearch = useCallback(
        (query?: string) => {
            dispatch(search(SearchPageType.BASIC, history, query));
            dispatch(fetchFacets(SearchPageType.BASIC, query));
        },
        [dispatch, history]
    );

    const onSourceSwitch = useCallback(
        (name: string) => {
            dispatch(searchSourceSwitchedAction(SearchPageType.BASIC, name));
            triggerSearch();
        },
        [dispatch, triggerSearch]
    );

    return (
        <Dropdown onToggle={onToggle} show={show} id={'search-sources-dropdown'}>
            <Dropdown.Toggle id={'search-sources-toggle'}>
                {renderSelectedValue()}
                <SvgIcon icon={Icons.CHEVRON_DOWN} id={'icon-down'}/>
            </Dropdown.Toggle>
            <Dropdown.Menu id={'search-sources-menu'} alignRight>
                {sources.map(({name}) => (
                    <Dropdown.Item key={name} onClick={() => onSourceSwitch(name)}>
                        <SvgIcon
                            icon={name === SearchSourceType.BOOKMARKS ? Icons.STAR : Icons.SEARCH_FOLDER}
                            className={classNames('icon-checkmark')}
                        />
                        {t('search.source.' + name)}
                    </Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
});
